import { Toast } from "@base-ui/react/toast";
const toastManager = Toast.createToastManager();
function addToast(type, title, options) {
    return toastManager.add({
        ...options,
        title,
        type
    });
}
const toast = {
    info: (title, options)=>addToast('info', title, options),
    success: (title, options)=>addToast('success', title, options),
    warning: (title, options)=>addToast('warning', title, options),
    error: (title, options)=>addToast('error', title, options),
    promise: (promiseValue, options)=>toastManager.promise(promiseValue, options),
    dismiss: (id)=>toastManager.close(id)
};
export { toast, toastManager };
